import { emailIpWarmingAppGroupIdPlan } from "../emailIpWarmingAppGroupIdPlan/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const postEmailIpWarmingAppGroupIdDeleteCacheKeys: AllRouteEndpoints[] = [
  emailIpWarmingAppGroupIdPlan,
  "/email/ip_warming/:app_group_id/plans",
];
